import React, {Component} from "react";
import apiClient from "api/client";
import DualListBox from 'react-dual-listbox';
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {css} from "@emotion/core";
import {BeatLoader} from "react-spinners";

const override = css`
    position: absolute;
    left: 47%;
    top: 30%;
    display: block;
    z-index: 1000;
    `;

class DualListBoxPackageSportEvent extends Component {

    constructor(props) {
        super(props);

        this.handleChannelSelect = this.handleChannelSelect.bind(this);

        this.state = {
            loading: false,

            availableSportEvents: [],
            selectedArray: [],
            sportEventProvider: null
        };
        this.onChange = this.onChange.bind(this);

    }

    handleChannelSelect(selected) {
        this.props.handlerFromParent(selected);
    }

    onChange(selected) {

        this.setState({selectedArray: selected});
        this.handleChannelSelect(selected)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.sportEventProvider !== prevProps.sportEventProvider) {
            this.loadAvailableSportEventsFromMiddleware()
        }
    }

    componentDidMount() {
        this.loadAvailableSportEventsFromMiddleware();
    }

    loadAvailableSportEventsFromMiddleware() {

        const url = process.env.REACT_APP_API_URL + "/PackageSportEvent/events?provider=" + this.props.sportEventProvider;

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };


        apiClient.get(url, axiosConfig)
            .then(res => {

                let temp = res.data;

                let availableSportEvents = [];
                let obj = {};

                for (let i = 0; i < temp.length; i++) {

                    obj = {
                        value: temp[i].value.toString(),
                        label: temp[i].label

                    }
                    availableSportEvents.push(obj)
                }

                const loading = false;

                this.setState({availableSportEvents, loading});
            })
            .catch(error => {
                console.log(error);
                this.props.dispatch(userActions.logoutUnauthorized());
            });

    }

    render() {
        return (
            <div>

                <div className="sweet-loader">
                    <BeatLoader
                        css={override}
                        size={5}
                        color={'#2c67a4'}
                        loading={this.state.loading}
                        //loading={true}
                    />
                </div>

                <DualListBox
                    options={this.state.availableSportEvents}
                    canFilter
                    availableLabel={"Available"}
                    selectedLabel={"Selected"}
                    showHeaderLabels
                    simpleValue={true}
                    selected={this.props.sportEventsInPackage}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}


function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDualListBoxPackageSportEvent = connect(mapStateToProps)(DualListBoxPackageSportEvent);
const connectedDualListBoxPackageSportEventTrans = withNamespaces('common')(connectedDualListBoxPackageSportEvent);
export {connectedDualListBoxPackageSportEventTrans as DualListBoxPackageSportEvent};
